import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { cx } from '../cx';
export interface ExpandableProps {
  expanded: boolean;
  children?: React.ReactNode;
}
export function Expandable(t0) {
  const $ = _c(20);
  const {
    expanded,
    children
  } = t0;
  const bodyRef = useRef(null);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");
  let t1;
  let t2;
  if ($[0] !== expanded) {
    t1 = () => {
      if (contentRef.current && bodyRef.current) {
        const rect = contentRef.current.getBoundingClientRect();
        if (expanded) {
          setHeight(rect.height + "px");
          return;
        }
        setHeight("0px");
      }
    };
    t2 = [expanded];
    $[0] = expanded;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cx("flex w-full flex-1 items-center overflow-hidden transition-all", "");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== height) {
    t4 = {
      height
    };
    $[4] = height;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = expanded ? "opacity-100" : "opacity-0";
  let t6;
  if ($[6] !== t5) {
    t6 = cx("flex-1 transition-all", t5, "");
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = expanded ? "scale-y-100" : "scale-y-0";
  let t8;
  if ($[8] !== t7) {
    t8 = cx("transition-transform", t7, "");
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== children || $[11] !== t8) {
    t9 = <div className={t8}>{children}</div>;
    $[10] = children;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div ref={contentRef} className={t6}>{t9}</div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== expanded || $[17] !== t10 || $[18] !== t4) {
    t11 = <div ref={bodyRef} className={t3} data-expanded={expanded} style={t4}>{t10}</div>;
    $[16] = expanded;
    $[17] = t10;
    $[18] = t4;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}